import React from 'react';
import { BannerProps, money } from './BannerProps';

const paper: React.CSSProperties = {
  background: '#fff',
  color: '#111',
  fontFamily: 'Helvetica, Arial, sans-serif',
  borderRadius: 6,
  padding: '12px 14px',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

/**
 * Design 1: "Services we offer" — the list. Check the services, set a
 * price, optionally discount any row. Owner-approved mockup #01.
 */
const ServicesListBanner: React.FC<BannerProps> = ({ promotion, brandColor = '#1e5aa8' }) => (
  <div style={paper}>
    <p style={{ fontSize: 11, letterSpacing: '0.12em', color: brandColor, fontWeight: 700, margin: '0 0 8px', textTransform: 'uppercase' }}>
      {promotion.headline ?? promotion.name}
    </p>
    {promotion.rows.map((row, i) => (
      <div
        key={`${row.label}-${i}`}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 10,
          fontSize: 13,
          padding: '6px 0',
          borderTop: i > 0 ? '1px solid #f1f4f7' : undefined,
          flexWrap: 'wrap',
        }}
      >
        <span style={{ minWidth: 0, overflowWrap: 'break-word' }}>{row.label}</span>
        <span style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'baseline', justifyContent: 'flex-end' }}>
          {row.wasCents !== null && (
            <span style={{ textDecoration: 'line-through', color: '#9aa2ac' }}>{money(row.wasCents)}</span>
          )}
          <span style={{ fontWeight: 700 }}>{money(row.priceCents)}</span>
          {row.percentOff !== null && (
            <span style={{ color: '#15803d', fontWeight: 700 }}>save {row.percentOff}%</span>
          )}
        </span>
      </div>
    ))}
    {promotion.finePrint && (
      <p style={{ fontSize: 11, color: '#6b7580', marginTop: 8, marginBottom: 0 }}>{promotion.finePrint}</p>
    )}
  </div>
);

export default ServicesListBanner;
